import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { CalendarMonth } from "@mui/icons-material";
import DateSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/DateSubtypeDetails";
import { DateModuleSubtypeResponse, DateSubtypeDataModel } from "./dateSubtype";
import DateSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/DateSubtypeSummary";
import DateEditorPreview from "../../../components/actionModules/subtypes/date/DateEditorPreview";
import { PropertyTypes } from "../editor/subtypeEditorTypes";
import DatePropertyEditor from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/DatePropertyEditor";


export const DateSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.date.name",
    type: Subtype.DateModuleSubtype,
    icon: <CalendarMonth />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<CalendarMonth />}
        name="actionModules.subtypes.date.name" />,
    editorPreview: (state) => <DateEditorPreview state={state}/>,
    subtypeDataView: (props) => <DateSubtypeDetails
        subtype={props.subtype as DateModuleSubtypeResponse}
        subtypeData={props.subtypeData as DateSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <DateSubtypeSummary
        subtype={props.subtype as DateModuleSubtypeResponse}
        subtypeData={props.subtypeData as DateSubtypeDataModel} />,
    editableProperties: [
        {
            name: "minDate",
            displayName: "actionModules.subtypes.date.minDate",
            propertyType: PropertyTypes.complex,
            editor: DatePropertyEditor,
        },
        {
            name: "maxDate",
            displayName: "actionModules.subtypes.date.maxDate",
            propertyType: PropertyTypes.complex,
            editor: DatePropertyEditor,
        },
        {
            name: "autoFillWithCurrentDate",
            displayName: "actionModules.subtypes.date.autoFillWithCurrentDate",
            defaultValue: true,
            propertyType: PropertyTypes.boolean,
        }
    ]
};
